import { usePage } from "@inertiajs/react";
import { useState, useEffect } from "react";

import { useToast } from "/utils/toast-context.jsx";

import Modal from "/components/Modal";
import Button from "/components/Button";
import TextField from "/components/TextField";
import TextArea from "/components/TextArea";
import Select from "/components/Select";
import ContactCard from "./ContactCard";
import ProjectLinksForm from "./ProjectLinksForm";

export default function CollectionForm({
  data,
  setData,
  onSubmit,
  errors,
}) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const { errorToast } = useToast();

  useEffect(() => {
    errors && errors.base && errors.base.forEach((error) => {
      errorToast(error);
    });
  }, [errors]);

  const genericSet = (attribute) =>
    (value) => setData((currentData) => ({ ...currentData, [attribute]: value }));

  const deleteCollection = async () => {
    const collectionId = collectionToDelete.id;
    await router.delete(`/admin/collections/${collectionId}`);
    setIsDeleteModalOpen(false);
  };

  const {
    contact_options,
  } = usePage().props;

  return (
    <>
      <Modal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        className="modal--autowidth"
      >
        <div className="modal__text">
          Вы уверены, что хотите<br />удалить эту коллекцию?
        </div>

        <div className="modal__actions">
          <Button onClick={deleteCollection} className="btn btn--dark">Удалить</Button>
          <Button onClick={() => setIsDeleteModalOpen(false)}>Отменить</Button>
        </div>
      </Modal>

      <div className="frm-wrapper">
        <form className="frm">
          <ActionsBar data={data} onSubmit={onSubmit} setIsDeleteModalOpen={setIsDeleteModalOpen} />

          <div className="inpt-line">
            <TextField
              label="Название коллекции"
              placeholder="Введите название коллекции"
              value={data.title_ru}
              onChange={genericSet("title_ru")}
              errors={errors?.title_ru}
            />

            <TextField
              label="Collection name"
              placeholder="Please specify the collection name"
              value={data.title_en}
              onChange={genericSet("title_en")}
              errors={errors?.title_en}
            />
          </div>

          <div className="inpt-line">
            <TextArea
              label="Описание коллекции"
              placeholder="Введите краткое описание коллекции, чтобы оно занимало 2-3 предложения"
              value={data.description}
              onChange={genericSet("description")}
              errors={errors?.description}
            />
          </div>

          <div className="inpt-line">
            <Select
              label="Продюсер"
              options={contact_options}
              locale="ru"
              placeholder="Выберите из списка"
              value={data.contact_id}
              onChange={genericSet("contact_id")}
              errors={errors?.contact}
            />

            <Select
              label="Contact"
              options={contact_options}
              locale="en"
              placeholder="Select from the Russian dropdown list"
              value={data.contact_id}
              disabled
            />
          </div>

          {data.contact_id && (
            <div className="inpt-line">
              <ContactCard
                contact={contact_options[data.contact_id].data}
                locale="ru"
              />

              <ContactCard
                contact={contact_options[data.contact_id].data}
                locale="en"
              />
            </div>
          )}

          <hr />

          <ProjectLinksForm
            project_links={data.project_links}
            onChange={genericSet("project_links")}
          />

          <ActionsBar data={data} onSubmit={onSubmit} setIsDeleteModalOpen={setIsDeleteModalOpen} />
        </form>
      </div>
    </>
  );
}

function ActionsBar({
  data,
  onSubmit,
  setIsDeleteModalOpen,
}) {
  return (
    <div className="actions-bar">
      <div>
        <Button onClick={() => onSubmit("change")} className="lnk lnk--green">Сохранить</Button>
        <Button onClick={() => onSubmit("publish")} className="lnk lnk--blue">Сохранить и опубликовать</Button>
        <Button onClick={() => onSubmit("change", true)} className="lnk">Превью</Button>
      </div>

      <div>
        <a href="/admin/projects" className="lnk">Отмена</a>
        <Button onClick={() => onSubmit("draft")} className="lnk">В черновики</Button>
        {data.id && <Button onClick={() => setIsDeleteModalOpen(true)} className="lnk lnk--red">Удалить</Button>}
      </div>
    </div>
  );
}
